import { Box, Container, Stack, Typography, styled } from "@mui/material";
import { PageTitle } from "../../../commanComponents/PageTitle";
import { JourneyProgressStepper } from "../../../commanComponents/JourneyProgressStepper";
import { String } from "../../../constants/Strings";

import { Button } from "@axismaxlife/unified-ui-components-library";
import { colors, fonts } from "../../../style";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataContext } from "../../../Hooks/context/ChildData";
import { AppToast } from "../../../commanComponents/AppToast";
import { useLocalStorage } from "../../../logic/LocalStorage/LocalStorage";
import { AuthContext } from "../../../Hooks/context/AuthContext";
import { useSavingGoals } from "../../../api/apiEndpoints/SavingGoals";
import { RetirementCards } from "../../../constants/RetirementsCardArray";
import { gaCustomEvent } from "../../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../../Hooks/context/OTPVeriryContext";

const StyledQuestion = styled(Typography)(({ theme }) => ({
  color: colors.NeutralDark700,
  fontSize: "1rem",
  fontFamily: fonts.manrope,
  fontWeight: 700,
  padding: theme.spacing(2),
}));

const StyledContent = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: "0.9rem",
  fontFamily: fonts.manrope,
  fontWeight: 600,
  width: "100%",
  textAlign: "left",
  padding: "6px 0",
}));

const Card = ({ card, index, selectedCardIndex, onClick }) => {
  const isSelected = selectedCardIndex === index;
  return (
    <Box
      onClick={() => onClick(index)}
      sx={{
        height: "100%",
        p: "8px",
        cursor: "pointer",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: isSelected
          ? colors.SecondarySummerSky
          : colors.ExtendedPalettesSummerSkySS100,
      }}
    >
      <Box
        sx={{
          p: "8px",
          borderRadius: "8px",
          backgroundColor: isSelected
            ? colors.PrimaryWhite
            : colors.ExtendedPalettesSummerSkySS100,
        }}
      >
        <Box
          component="img"
          src={card.image}
          alt=""
          aria-hidden="true"
          sx={{ display: "block", width: "50px", height: "auto" }}
        />
      </Box>
      <Box
        component="span"
        sx={{
          mt: "8px",
          pb: "4px",
          fontSize: "14px",
          fontFamily: fonts.manrope,
          fontWeight: 700,
          color: isSelected
            ? colors.PrimaryWhite
            : colors.SecondaryMidnightBlue,
        }}
      >
        {card.text}
      </Box>
    </Box>
  );
};
const RetirementGoal = () => {
  const [selectedCardIndex, setSelectedCardIndex] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const navigation = useNavigate();
  const { collectedData, collectData } = useContext(DataContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const { saveLocalFinancialData, retrieveLocalFinancialData } =
    useLocalStorage();
  const { saveGoals } = useSavingGoals();
  const { authTokens } = useContext(AuthContext);

  const { userId } = authTokens;

  const { question1 } = String.Retirement.SecondInning;

  const onHandleClick = (index, card) => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioRetirementGoal,
      verifyData.customerId,
    );

    setSelectedCardIndex(index);
    if (card === "Current Comfort") {
      setSelectedCard("Maintain Status Quo");
    } else {
      setSelectedCard(card);
    }
  };

  useEffect(() => {
    const retrieveSavedData = async () => {
      try {
        const data = await retrieveLocalFinancialData(
          `retirementgoal-${userId}`,
        );

        if (data) {
          setSelectedCardIndex(data.selectedCardIndex);
          setSelectedCard(data.selectedCard);
        } else {
          setSelectedCard(null);
        }
      } catch (e) { }
    };
    retrieveSavedData();
  }, []);
  const showSnackbar = (message, severity) => {
    setSnackbarMessage({ message, severity });
    setSnackbarOpen(true);
  };

  const handleContineu = async () => {
    gaCustomEvent(
      String.gaEventName.acrPortfolio,
      String.gaEventClickName.acrPortfolioRetirementGoalContinue,
      verifyData.customerId,
    );
    if (selectedCard !== "" && !selectedCard) {
      showSnackbar(
        String.Retirement.SecondInning.selectGoal,
        String.ErrorSeverity,
      );
      return;
    }
    saveLocalFinancialData(`retirementgoal-${userId}`, {
      selectedCard,
      selectedCardIndex,
    });

    collectData({ ...collectedData, selectedCard: selectedCard });
    try {
      const investment = collectedData.investment || {};
      const data = {
        userId: userId,
        isParent: collectedData.isParent || false,
        futureGoalName: investment.goalName || "",
        requiredAmount: investment.finaicalGoalMoney || "",
        targetYear: investment.years || "",
        idealRetirement: selectedCard,
        children: collectedData.children ? collectedData.children : [],
        dependants: collectedData.dependants ? collectedData.dependants : [],
        goals: [...(collectedData.selectedGoals || [])],
      };

      const response = await saveGoals(data);
      if (response.httpCode === 200) {
        showSnackbar(String.successMessageforGoalsave, String.successSeverity);
        setTimeout(() => {
          navigation(String.navigations.fetchinfo);
        }, 500);
      } else {
        showSnackbar(String.errorMessageforGoalsave, String.ErrorSeverity);
      }
    } catch (error) {
      showSnackbar(String.errorMessageforGoalsave, String.ErrorSeverity);
    }
  };
  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container>
        <PageTitle />
        <JourneyProgressStepper />
      </Container>
      <Container sx={{ textAlign: "left" }}>
        <StyledQuestion sx={{ px: 0 }}>{question1}</StyledQuestion>
        <Stack direction="row" spacing="12px" sx={{ alignItems: "stretch" }}>
          {RetirementCards.map((card, index) => (
            <Box key={index} sx={{ flex: 1 }}>
              <Card
                card={card}
                index={index}
                selectedCardIndex={selectedCardIndex}
                onClick={() => onHandleClick(index, card.text)}
              />
            </Box>
          ))}
        </Stack>
        {selectedCardIndex !== null && (
          <StyledContent sx={{ mt: "16px", px: 0, textAlign: "left" }}>
            {RetirementCards[selectedCardIndex].description}
          </StyledContent>
        )}
      </Container>

      <Container sx={{ mt: "auto", mb: "16px" }}>
        <Button
          buttonType="primary"
          width="100%"
          disabled={selectedCardIndex === null}
          onClick={handleContineu}
        >
          {String.continue}
        </Button>
      </Container>
      <AppToast
        open={snackbarOpen}
        handleClose={() => setSnackbarOpen(false)}
        severity={snackbarmessage.severity}
        message={snackbarmessage.message}
      />
    </Box>
  );
};

export default RetirementGoal;
